module.exports = __webpack_public_path__ + "static/media/facebook.45099b3b.svg";